var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderFavouriteBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83335 5.41732H13.9584C15.7142 5.41732 16.5917 5.41732 17.2225 5.83898C17.4952 6.02127 17.7294 6.25544 17.9117 6.52815C18.2617 7.05315 18.3217 7.89148 18.3317 9.16732M10 5.41732L9.47252 4.36148C9.03502 3.48648 8.63502 2.60648 7.66585 2.24315C7.24169 2.08398 6.75669 2.08398 5.78669 2.08398C4.27335 2.08398 3.51669 2.08398 2.94835 2.40065C2.54342 2.6266 2.2093 2.96071 1.98335 3.36565C1.66669 3.93398 1.66669 4.69065 1.66669 6.20398V8.75065C1.66669 12.679 1.66669 14.6432 2.88669 15.8632C3.97002 16.9465 5.64002 17.069 8.75002 17.0823M11.785 11.619C12.7909 11.009 13.6684 11.2548 14.1959 11.6457C14.4117 11.8065 14.52 11.8865 14.5834 11.8865C14.6467 11.8865 14.755 11.8065 14.9709 11.6457C15.4984 11.2548 16.3759 11.009 17.3817 11.619C18.7017 12.4182 19 15.0557 15.9567 17.2815C15.3759 17.7048 15.0867 17.9173 14.5834 17.9173C14.08 17.9173 13.7909 17.7048 13.2109 17.2815C10.1667 15.0565 10.465 12.4182 11.785 11.619Z",
    stroke: "#243C7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFavouriteBold);
export default __webpack_public_path__ + "static/media/folder-favourite-bold.c0582f3fa81017d8232d69b9cb8a4832.svg";
export { ForwardRef as ReactComponent };